import { useCallback, type ComponentProps, type MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from 'services/hooks';
import { locations } from 'services/routes/locations';
import NavLink from '../NavLink';

type ProtectedNavLinkProps = ComponentProps<typeof NavLink>;

const ProtectedNavLink = (props: ProtectedNavLinkProps) => {
  const { to, onClick } = props;

  const navigate = useNavigate();
  const {
    authStore: { isLoggedIn },
  } = useAuthStore();

  const handleProtectedClick = useCallback(
    (event: MouseEvent<HTMLAnchorElement>) => {
      onClick?.(event);

      if (!isLoggedIn) {
        event.preventDefault();
        navigate(locations.general.register.pathname(''), {
          state: { from: { pathname: to } },
        });
      }
    },
    [isLoggedIn, navigate, to, onClick]
  );

  return <NavLink {...props} onClick={handleProtectedClick} />;
};

export default ProtectedNavLink;
